import { createMobileSliderNav, updateMobileSliderCurrentActive } from '@lib/mobile-slider-nav';

function initSlider(slider) {
    if (slider.dataset.sliderInitialized) return;
    slider.dataset.sliderInitialized = true.toString();

    let currentItem = 0;

    const line = slider.querySelector('[data-slider-line]');
    const prevBtn = slider.querySelectorAll('[data-slider-prev]');
    const nextBtn = slider.querySelectorAll('[data-slider-next]');
    const gap = slider.dataset.sliderGap ? +slider.dataset.sliderGap : 0;

    const mobileNav = slider.querySelector('[data-slider-mobile-nav]');
    createMobileSliderNav({ element: mobileNav, itemsCount: line.children.length, prev, next });

    prevBtn.forEach((el) => el.addEventListener('click', prev));
    nextBtn.forEach((el) => el.addEventListener('click', next));

    changeCurrentItem(0);

    function prev() {
        changeCurrentItem(currentItem - 1);
    }

    function next() {
        changeCurrentItem(currentItem + 1);
    }

    function changeCurrentItem(nextItem) {
        currentItem = nextItem;
        const elementWidth = line.children[0].offsetWidth;

        line.style.transform = `translateX(-${elementWidth * currentItem + gap * currentItem}px)`;

        const prevDisabled = currentItem === 0;
        prevBtn.forEach((el) => (el.disabled = prevDisabled));

        const nextDisabled = currentItem === line.children.length - 1;
        nextBtn.forEach((el) => (el.disabled = nextDisabled));

        updateMobileSliderCurrentActive(mobileNav, currentItem);
    }
}

window.Drupal.behaviors.slider = {
    attach: function (context) {
        context.querySelectorAll('[data-slider]').forEach(initSlider);
    },
};
